import type { FC, SVGProps } from 'react';

import ArrowLeftIconSvg from './arrow-left.svg';

/** Иконка стрелки влево (навигация календаря). */
const ArrowLeftIcon: FC<SVGProps<SVGSVGElement>> = ArrowLeftIconSvg;

export default ArrowLeftIcon;
